import React, { useState } from 'react';

export const QuizzesTab = ({ quizzes = [], onEdit, onCreate, onDelete, isDarkMode }) => (
  <div>
    <div className="flex justify-between items-center mb-6">
      <h4 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        Quiz Questions ({(quizzes || []).length})
      </h4>
      <button
        onClick={onCreate}
        className="bg-gradient-to-r from-purple-500 to-pink-600 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all"
      >
        + Add Quiz
      </button>
    </div>

    <div className="grid gap-4">
      {(quizzes || []).map(quiz => (
        <div key={quiz.id} className={`p-4 rounded-lg border-2 ${isDarkMode ? 'bg-gray-600 border-gray-500' : 'bg-gray-50 border-gray-200'}`}>
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <span className={`px-2 py-1 rounded text-xs font-bold ${
                  quiz.difficulty === 'easy' ? 'bg-green-100 text-green-700' :
                  quiz.difficulty === 'medium' ? 'bg-yellow-100 text-yellow-700' :
                  'bg-red-100 text-red-700'
                }`}>
                  {quiz.difficulty}
                </span>
                <span className={`px-2 py-1 rounded text-xs font-bold ${
                  quiz.category === 'darija' ? 'bg-blue-100 text-blue-700' :
                  quiz.category === 'math' ? 'bg-purple-100 text-purple-700' :
                  'bg-orange-100 text-orange-700'
                }`}>
                  {quiz.category}
                </span>
                <span className={`px-2 py-1 rounded text-xs font-bold ${
                  quiz.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'
                }`}>
                  {quiz.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              <p className={`font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                {quiz.question}
              </p>
              <div className="grid grid-cols-2 gap-2 text-sm">
                {quiz.options?.map((option, idx) => (
                  <div key={idx} className={`p-2 rounded ${
                    idx === quiz.correct_index 
                      ? 'bg-green-100 text-green-800 font-semibold' 
                      : isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-white text-gray-600'
                  }`}>
                    {idx === quiz.correct_index && '✅ '}{option}
                  </div>
                ))}
              </div>
              <div className="mt-2 text-sm text-gray-500">
                Reward: +{quiz.reward} DH | Penalty: -{quiz.penalty} DH
              </div>
            </div>
            <div className="flex gap-2 ml-4">
              <button
                onClick={() => onEdit(quiz)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(quiz.id)}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
      {quizzes.length === 0 && (
        <p className="text-center text-gray-500 py-8">No quizzes yet. Add your first quiz!</p>
      )}
    </div>
  </div>
);

export const CulturalTipsTab = ({ tips = [], onEdit, onCreate, onDelete, isDarkMode }) => (
  <div>
    <div className="flex justify-between items-center mb-6">
      <h4 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        Cultural Tips ({(tips || []).length})
      </h4>
      <button
        onClick={onCreate}
        className="bg-gradient-to-r from-orange-500 to-yellow-600 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all"
      >
        + Add Tip
      </button>
    </div>

    <div className="grid gap-4">
      {(tips || []).map(tip => (
        <div key={tip.id} className={`p-4 rounded-lg border-2 ${isDarkMode ? 'bg-gray-600 border-gray-500' : 'bg-orange-50 border-orange-200'}`}>
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-3xl">{tip.emoji}</span>
                <div>
                  <h5 className={`font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                    {tip.title}
                  </h5>
                  <span className="text-xs text-gray-500">{tip.category}</span>
                </div>
              </div>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                {tip.tip}
              </p>
            </div>
            <div className="flex gap-2 ml-4">
              <button
                onClick={() => onEdit(tip)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(tip.id)}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
      {tips.length === 0 && (
        <p className="text-center text-gray-500 py-8">No tips yet. Add your first cultural tip!</p>
      )}
    </div>
  </div>
);

export const DarijaPhrasesTab = ({ phrases = [], onEdit, onCreate, onDelete, isDarkMode }) => (
  <div>
    <div className="flex justify-between items-center mb-6">
      <h4 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        Darija Phrases ({(phrases || []).length})
      </h4>
      <button
        onClick={onCreate}
        className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all"
      >
        + Add Phrase
      </button>
    </div>

    <div className="grid gap-4">
      {(phrases || []).map(phrase => (
        <div key={phrase.id} className={`p-4 rounded-lg border-2 ${isDarkMode ? 'bg-gray-600 border-gray-500' : 'bg-blue-50 border-blue-200'}`}>
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-3xl">{phrase.emoji}</span>
                <div className="flex-1">
                  <p className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-purple-600'}`}>
                    {phrase.darija}
                  </p>
                  <p className="text-sm text-gray-500 italic">"{phrase.pronunciation}"</p>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                    = {phrase.english}
                  </p>
                  <span className="text-xs text-gray-500">{phrase.category}</span>
                </div>
              </div>
            </div>
            <div className="flex gap-2 ml-4">
              <button
                onClick={() => onEdit(phrase)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(phrase.id)}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
      {phrases.length === 0 && (
        <p className="text-center text-gray-500 py-8">No phrases yet. Add your first Darija phrase!</p>
      )}
    </div>
  </div>
);

export const WheelSettingsTab = ({ settings, onChange, onSave, isDarkMode }) => {
  if (!settings) return <div>Loading...</div>;
  
  const addSegment = () => {
    const newSegments = [...(settings.segments || []), {
      label: "New Prize",
      value: 0,
      color: "#" + Math.floor(Math.random()*16777215).toString(16)
    }];
    onChange({...settings, segments: newSegments});
  };
  
  const removeSegment = (idx) => {
    const newSegments = settings.segments.filter((_, i) => i !== idx);
    onChange({...settings, segments: newSegments});
  };
  
  const updateSegment = (idx, field, value) => {
    const newSegments = [...settings.segments];
    newSegments[idx] = {...newSegments[idx], [field]: value};
    onChange({...settings, segments: newSegments});
  };
  
  return (
    <div>
      <h4 className={`text-xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        Mystery Wheel Configuration
      </h4>

      <div className="space-y-6">
        {/* Temu-Style Controls Banner */}
        <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-gradient-to-r from-purple-900 to-pink-900' : 'bg-gradient-to-r from-purple-100 to-pink-100'}`}>
          <h5 className={`font-bold text-lg ${isDarkMode ? 'text-white' : 'text-purple-800'}`}>
            🎡 Full Wheel Control (Temu-Style)
          </h5>
          <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            Control spin frequency, daily limits, probabilities, and gamification features
          </p>
        </div>

        {/* Trigger & Timing Settings */}
        <div className={`p-4 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
          <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>⚡ Trigger & Timing</h5>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <label className={`block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Trigger Chance (%)
              </label>
              <input
                type="number"
                min="0"
                max="100"
                value={(settings.trigger_chance * 100).toFixed(0)}
                onChange={(e) => onChange({...settings, trigger_chance: parseInt(e.target.value) / 100})}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Chance after cooldown</p>
            </div>
            <div>
              <label className={`block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Min Actions Required
              </label>
              <input
                type="number"
                min="1"
                value={settings.min_actions_required || 3}
                onChange={(e) => onChange({...settings, min_actions_required: parseInt(e.target.value)})}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Before wheel appears</p>
            </div>
            <div>
              <label className={`block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Cooldown (seconds)
              </label>
              <input
                type="number"
                min="10"
                value={settings.cooldown_seconds || 300}
                onChange={(e) => onChange({...settings, cooldown_seconds: parseInt(e.target.value)})}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Time between spins</p>
            </div>
          </div>
          
          {/* Toggle Options */}
          <div className="grid grid-cols-2 gap-4 mt-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.auto_trigger_enabled !== false}
                onChange={(e) => onChange({...settings, auto_trigger_enabled: e.target.checked})}
                className="w-4 h-4"
              />
              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Auto-trigger popup</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.show_wheel_button !== false}
                onChange={(e) => onChange({...settings, show_wheel_button: e.target.checked})}
                className="w-4 h-4"
              />
              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Show "Try Luck" button</span>
            </label>
          </div>
        </div>

        {/* Daily Limits & Attempts */}
        <div className={`p-4 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
          <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>🎯 Spin Limits & Attempts</h5>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className={`block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Max Daily Spins
              </label>
              <input
                type="number"
                min="1"
                max="10"
                value={settings.max_daily_spins || 3}
                onChange={(e) => onChange({...settings, max_daily_spins: parseInt(e.target.value)})}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Lifetime Spins (optional)
              </label>
              <input
                type="number"
                min="0"
                placeholder="Unlimited"
                value={settings.max_lifetime_spins || ''}
                onChange={(e) => onChange({...settings, max_lifetime_spins: e.target.value ? parseInt(e.target.value) : null})}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={settings.first_time_bonus !== false}
                  onChange={(e) => onChange({...settings, first_time_bonus: e.target.checked})}
                  className="w-4 h-4"
                />
                <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>First-time bonus</span>
              </label>
            </div>
          </div>
        </div>

        {/* Gamification Features */}
        <div className={`p-4 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
          <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>🎮 Gamification Features</h5>
          <div className="grid grid-cols-3 gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.share_bonus_enabled !== false}
                onChange={(e) => onChange({...settings, share_bonus_enabled: e.target.checked})}
                className="w-4 h-4"
              />
              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Share bonus (extra spin)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.consecutive_day_bonus !== false}
                onChange={(e) => onChange({...settings, consecutive_day_bonus: e.target.checked})}
                className="w-4 h-4"
              />
              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Consecutive day bonus</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.require_achievement !== true}
                onChange={(e) => onChange({...settings, require_achievement: e.target.checked})}
                className="w-4 h-4"
              />
              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Require achievement</span>
            </label>
          </div>
        </div>

        {/* Wheel Segments Editor */}
        <div>
          <div className="flex justify-between items-center mb-4">
            <h5 className={`font-bold text-lg ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
              Wheel Segments
            </h5>
            <button
              onClick={addSegment}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
            >
              + Add Segment
            </button>
          </div>
          
          <div className="space-y-3">
            {settings.segments?.map((segment, idx) => (
              <div key={idx} className={`p-4 rounded-lg border-2 ${isDarkMode ? 'bg-gray-700' : 'bg-white'}`} style={{borderColor: segment.color}}>
                <div className="grid grid-cols-12 gap-3 items-center">
                  {/* Color Picker */}
                  <div className="col-span-1">
                    <input
                      type="color"
                      value={segment.color}
                      onChange={(e) => updateSegment(idx, 'color', e.target.value)}
                      className="w-full h-10 rounded cursor-pointer"
                      title="Pick color"
                    />
                  </div>
                  
                  {/* Label */}
                  <div className="col-span-3">
                    <input
                      type="text"
                      value={segment.label}
                      onChange={(e) => updateSegment(idx, 'label', e.target.value)}
                      placeholder="e.g., 50 DH"
                      className={`w-full px-3 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  
                  {/* Value */}
                  <div className="col-span-2">
                    <input
                      type="number"
                      value={segment.value}
                      onChange={(e) => updateSegment(idx, 'value', parseInt(e.target.value) || 0)}
                      placeholder="Coins"
                      className={`w-full px-3 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  
                  {/* Probability */}
                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        type="number"
                        value={segment.probability || 25}
                        onChange={(e) => updateSegment(idx, 'probability', parseInt(e.target.value) || 0)}
                        min="0"
                        max="100"
                        placeholder="%"
                        className={`w-full px-3 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                      />
                      <span className={`absolute right-2 top-2 text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>%</span>
                    </div>
                    <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Win rate</p>
                  </div>
                  
                  {/* Preview */}
                  <div className="col-span-3 text-center">
                    <div className="px-3 py-2 rounded-lg font-bold text-sm" style={{backgroundColor: segment.color + '30', color: segment.color}}>
                      {segment.label}
                      <br />
                      <span className="text-xs opacity-70">{segment.probability || 25}% chance</span>
                    </div>
                  </div>
                  
                  {/* Delete */}
                  <div className="col-span-1">
                    <button
                      onClick={() => removeSegment(idx)}
                      className="w-full bg-red-600 hover:bg-red-700 text-white px-2 py-2 rounded-lg"
                      title="Delete segment"
                    >
                      🗑️
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Wheel Preview */}
        <div className={`p-6 rounded-lg border-2 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-300'}`}>
          <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            🎡 Wheel Preview
          </h5>
          <div className="flex justify-center">
            <div className="relative" style={{width: '300px', height: '300px'}}>
              <svg width="300" height="300" viewBox="0 0 300 300">
                <g id="wheel">
                  {settings.segments?.map((segment, idx) => {
                    const totalSegments = settings.segments.length;
                    const anglePerSegment = 360 / totalSegments;
                    const startAngle = idx * anglePerSegment - 90;
                    const endAngle = startAngle + anglePerSegment;
                    
                    const startRad = (startAngle * Math.PI) / 180;
                    const endRad = (endAngle * Math.PI) / 180;
                    
                    const x1 = 150 + 140 * Math.cos(startRad);
                    const y1 = 150 + 140 * Math.sin(startRad);
                    const x2 = 150 + 140 * Math.cos(endRad);
                    const y2 = 150 + 140 * Math.sin(endRad);
                    
                    const largeArcFlag = anglePerSegment > 180 ? 1 : 0;
                    
                    return (
                      <g key={idx}>
                        <path
                          d={`M 150 150 L ${x1} ${y1} A 140 140 0 ${largeArcFlag} 1 ${x2} ${y2} Z`}
                          fill={segment.color}
                          stroke="white"
                          strokeWidth="2"
                        />
                        <text
                          x={150 + 90 * Math.cos((startRad + endRad) / 2)}
                          y={150 + 90 * Math.sin((startRad + endRad) / 2)}
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fill="white"
                          fontSize="14"
                          fontWeight="bold"
                          style={{textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}
                        >
                          {segment.label}
                        </text>
                      </g>
                    );
                  })}
                </g>
                {/* Center circle */}
                <circle cx="150" cy="150" r="35" fill="white" stroke="#333" strokeWidth="3"/>
                <text x="150" y="155" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">SPIN</text>
                {/* Spinning arrow pointer - positioned at center, points up */}
                <g transform="translate(150, 150)">
                  <polygon points="0,-140 -8,-115 8,-115" fill="#FF0000" stroke="#333" strokeWidth="2" style={{filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.5))'}}/>
                </g>
              </svg>
            </div>
          </div>
        </div>

        <div className="flex gap-4">
          <button
            onClick={() => {
              const previewWindow = window.open('', 'WheelPreview', 'width=600,height=700');
              const segments = settings.segments || [];
              previewWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                  <title>Wheel Preview</title>
                  <style>
                    body {
                      margin: 0;
                      padding: 20px;
                      font-family: system-ui, -apple-system, sans-serif;
                      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      min-height: 100vh;
                    }
                    .modal {
                      background: white;
                      border-radius: 20px;
                      padding: 30px;
                      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
                      max-width: 500px;
                      text-align: center;
                    }
                    h2 { color: #333; margin-bottom: 20px; }
                    .wheel-container {
                      margin: 20px 0;
                      position: relative;
                    }
                    .spin-btn {
                      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                      color: white;
                      border: none;
                      padding: 15px 40px;
                      border-radius: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      cursor: pointer;
                      margin-top: 20px;
                      box-shadow: 0 4px 15px rgba(0,0,0,0.2);
                    }
                    .spin-btn:hover {
                      transform: scale(1.05);
                    }
                    .stats {
                      margin-top: 20px;
                      padding: 15px;
                      background: #f0f0f0;
                      border-radius: 10px;
                      font-size: 14px;
                    }
                  </style>
                </head>
                <body>
                  <div class="modal">
                    <h2>🎡 Mystery Wheel Preview v2.0</h2>
                    <p>Daily Spins: ${settings.max_daily_spins || 3} | Cooldown: ${(settings.cooldown_seconds || 300)/60} mins</p>
                    <p style="font-size: 12px; color: #fff;">✅ UPDATED: Simple Angle Range Method Active</p>
                    <div class="wheel-container">
                      <svg width="300" height="300" viewBox="0 0 300 300">
                        <g id="wheel">
                          ${settings.segments.map((seg, idx) => {
                            const total = settings.segments.length;
                            const angle = 360 / total;
                            const startAngle = idx * angle - 90;
                            const endAngle = startAngle + angle;
                            const startRad = (startAngle * Math.PI) / 180;
                            const endRad = (endAngle * Math.PI) / 180;
                            const x1 = 150 + 140 * Math.cos(startRad);
                            const y1 = 150 + 140 * Math.sin(startRad);
                            const x2 = 150 + 140 * Math.cos(endRad);
                            const y2 = 150 + 140 * Math.sin(endRad);
                            const largeArc = angle > 180 ? 1 : 0;
                            const textX = 150 + 90 * Math.cos((startRad + endRad) / 2);
                            const textY = 150 + 90 * Math.sin((startRad + endRad) / 2);
                            return '<path d="M 150 150 L ' + x1 + ' ' + y1 + ' A 140 140 0 ' + largeArc + ' 1 ' + x2 + ' ' + y2 + ' Z" fill="' + seg.color + '" stroke="white" stroke-width="2"/><text x="' + textX + '" y="' + textY + '" text-anchor="middle" dominant-baseline="middle" fill="white" font-size="14" font-weight="bold" style="text-shadow: 1px 1px 2px rgba(0,0,0,0.5)">' + seg.label + '</text>';
                          }).join('')}
                        </g>
                        <circle cx="150" cy="150" r="35" fill="white" stroke="#333" stroke-width="3"/>
                        <text x="150" y="155" text-anchor="middle" font-size="18" font-weight="bold" fill="#333">SPIN</text>
                        <g id="pointer" transform="translate(150, 150)">
                          <polygon points="0,-140 -8,-115 8,-115" fill="#FF0000" stroke="#333" stroke-width="2" style="filter: drop-shadow(2px 2px 4px rgba(0,0,0,0.5))"/>
                        </g>
                      </svg>
                    </div>
                    <button class="spin-btn" id="spinBtn" onclick="spinWheel()">🎡 SPIN NOW!</button>
                    <div id="result" style="margin-top: 20px; font-size: 24px; font-weight: bold; color: #667eea;"></div>
                    <div style="margin-top: 15px; padding: 12px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px; font-size: 13px; color: #856404;">
                      <strong>📚 Educational Purpose:</strong> This is a learning platform for Darija. Not a real marketplace.
                    </div>
                    <script>
                      let spinning = false;
                      const segments = ${JSON.stringify(segments)};
                      let currentRotation = 0;
                      
                      function spinWheel() {
                        if (spinning) return;
                        spinning = true;
                        
                        const wheelGroup = document.getElementById('wheel');
                        const pointerGroup = document.getElementById('pointer');
                        const btn = document.getElementById('spinBtn');
                        const resultDiv = document.getElementById('result');
                        
                        btn.disabled = true;
                        btn.textContent = '🎡 SPINNING...';
                        resultDiv.textContent = '';
                        
                        // Make sure pointer stays fixed at top
                        pointerGroup.style.transform = 'translate(150px, 150px) rotate(0deg)';
                        pointerGroup.style.transition = 'none';
                        
                        // Random spin between 2000 and 4000 degrees
                        const spinDegrees = 2000 + Math.random() * 2000;
                        currentRotation += spinDegrees;
                        
                        // Apply rotation to WHEEL ONLY (not arrow)
                        wheelGroup.style.transformOrigin = '150px 150px';
                        wheelGroup.style.transition = 'transform 5s cubic-bezier(0.17, 0.67, 0.12, 0.99)';
                        wheelGroup.style.transform = 'rotate(' + currentRotation + 'deg)';
                        
                        setTimeout(() => {
                          // SIMPLE ANGLE RANGE METHOD
                          // Segments start at -90° (top where arrow points) and go clockwise
                          // Each segment has equal angle size
                          const anglePerSegment = 360 / segments.length;
                          
                          // Get final angle (0-360)
                          const finalAngle = currentRotation % 360;
                          
                          // Adjust for segments starting at -90° (270° in 0-360 range)
                          // Arrow is at top = 270° in standard coords
                          const adjustedAngle = (finalAngle + 90) % 360;
                          
                          // Find which segment range this angle falls into
                          const winnerIndex = Math.floor(adjustedAngle / anglePerSegment) % segments.length;
                          const winner = segments[winnerIndex];
                          
                          // Calculate the angle range for this segment
                          const segmentStart = winnerIndex * anglePerSegment;
                          const segmentEnd = segmentStart + anglePerSegment;
                          
                          console.log('═══════════════════════════════════');
                          console.log('🎡 WHEEL SPIN RESULT');
                          console.log('═══════════════════════════════════');
                          console.log('🔄 Total Rotation: ' + currentRotation.toFixed(1) + '°');
                          console.log('📐 Final Angle (0-360): ' + finalAngle.toFixed(1) + '°');
                          console.log('📐 Adjusted Angle: ' + adjustedAngle.toFixed(1) + '°');
                          console.log('📏 Segment Size: ' + anglePerSegment.toFixed(1) + '°');
                          console.log('───────────────────────────────────');
                          console.log('🎯 WINNER:');
                          console.log('   Index: ' + winnerIndex);
                          console.log('   Prize: ' + winner.label);
                          console.log('   Color: ' + winner.color);
                          console.log('   Angle Range: ' + segmentStart.toFixed(1) + '° to ' + segmentEnd.toFixed(1) + '°');
                          console.log('   Stopped at: ' + adjustedAngle.toFixed(1) + '° ✓');
                          console.log('═══════════════════════════════════');
                          
                          var esc = function(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
                          resultDiv.innerHTML = '🎉 YOU WON:<br/><span style="font-size: 32px; color: ' + esc(winner.color) + ';">' + esc(winner.label) + '</span>!';
                          btn.textContent = '🎡 SPIN AGAIN';
                          btn.disabled = false;
                          spinning = false;
                        }, 5000);
                      }
                    </script>
                    <div class="stats">
                      <strong>Probability Distribution:</strong><br/>
                      ${settings.segments.map(s => s.label + ': ' + (s.probability || 25) + '%').join(' | ')}
                    </div>
                  </div>
                </body>
                </html>
              `);
            }}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold"
          >
            👁️ Preview Wheel
          </button>
          <button
            onClick={onSave}
            className="flex-1 bg-gradient-to-r from-purple-500 to-pink-600 text-white py-3 rounded-lg font-bold hover:shadow-lg transition-all"
          >
            💾 Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export const MerchantPhrasesTab = ({ phrases, merchants, onEdit, onCreate, onDelete, isDarkMode }) => {
  // Group phrases by merchant
  const phrasesByMerchant = phrases.reduce((acc, phrase) => {
    if (!acc[phrase.merchant_id]) {
      acc[phrase.merchant_id] = [];
    }
    acc[phrase.merchant_id].push(phrase);
    return acc;
  }, {});

  const getMerchantName = (merchantId) => {
    const merchant = merchants.find(m => m.id === merchantId);
    return merchant ? merchant.name_english : 'Unknown Merchant';
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h4 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          🏪💬 Merchant-Specific Phrases ({phrases.length})
        </h4>
        <button
          onClick={onCreate}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium"
        >
          + Add Merchant Phrase
        </button>
      </div>

      <div className={`mb-4 p-4 rounded-lg ${isDarkMode ? 'bg-blue-900/30 border border-blue-700' : 'bg-blue-50 border border-blue-200'}`}>
        <p className={`text-sm ${isDarkMode ? 'text-blue-300' : 'text-blue-800'}`}>
          💡 <strong>Note:</strong> These phrases appear under each merchant's profile in the "Learn Useful Phrases" section, helping users learn context-specific Darija for shopping.
        </p>
      </div>

      <div className="space-y-6">
        {merchants.map(merchant => {
          const merchantPhrs = phrasesByMerchant[merchant.id] || [];
          return (
            <div key={merchant.id} className={`p-4 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
              <h5 className={`text-lg font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                🏪 {merchant.name_english} ({merchantPhrs.length} phrases)
              </h5>
              
              {merchantPhrs.length === 0 ? (
                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  No phrases added for this merchant yet.
                </p>
              ) : (
                <div className="space-y-2">
                  {merchantPhrs.map(phrase => (
                    <div key={phrase.id} className={`p-3 rounded-lg ${isDarkMode ? 'bg-gray-600' : 'bg-gray-50'}`}>
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <div className={`font-bold text-lg ${isDarkMode ? 'text-blue-300' : 'text-blue-600'}`}>
                            {phrase.darija}
                          </div>
                          <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            = {phrase.english}
                          </div>
                          <div className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            "{phrase.pronunciation}"
                          </div>
                          {phrase.audio_link && (
                            <div className={`text-xs mt-1 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                              🔊 Audio available
                            </div>
                          )}
                          <div className={`text-xs mt-1 ${isDarkMode ? 'text-gray-500' : 'text-gray-600'}`}>
                            Context: {phrase.context}
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => onEdit(phrase)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => onDelete(phrase.id)}
                            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const EarningOpportunitiesTab = ({ settings, onChange, onSave, isDarkMode }) => {
  if (!settings || !settings.options) return <div>Loading...</div>;

  const updateOption = (optionId, field, value) => {
    const newOptions = settings.options.map(opt => 
      opt.id === optionId ? {...opt, [field]: value} : opt
    );
    onChange({...settings, options: newOptions});
  };

  return (
    <div>
      <h4 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        💰✨ "Want to Earn More?" Popup Configuration
      </h4>

      {/* Popup Header Settings */}
      <div className={`p-4 mb-6 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
        <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>📝 Popup Header</h5>
        <div className="space-y-3">
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Title</label>
            <input
              type="text"
              value={settings.title}
              onChange={(e) => onChange({...settings, title: e.target.value})}
              className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Subtitle</label>
            <input
              type="text"
              value={settings.subtitle}
              onChange={(e) => onChange({...settings, subtitle: e.target.value})}
              className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
        </div>
      </div>

      {/* Trigger Settings */}
      <div className={`p-4 mb-6 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
        <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>⚡ Trigger Settings</h5>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Trigger After Actions
            </label>
            <input
              type="number"
              min="1"
              value={settings.trigger_after_actions}
              onChange={(e) => onChange({...settings, trigger_after_actions: parseInt(e.target.value)})}
              className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Trigger Probability (%)
            </label>
            <input
              type="number"
              min="0"
              max="100"
              value={(settings.trigger_probability * 100).toFixed(0)}
              onChange={(e) => onChange({...settings, trigger_probability: parseInt(e.target.value) / 100})}
              className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Cooldown (minutes)
            </label>
            <input
              type="number"
              min="1"
              value={settings.cooldown_minutes}
              onChange={(e) => onChange({...settings, cooldown_minutes: parseInt(e.target.value)})}
              className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
        </div>
      </div>

      {/* Earning Options */}
      <div className={`p-4 mb-6 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
        <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>🎁 Earning Options (User Choices)</h5>
        <div className="space-y-3">
          {settings.options.map((option) => (
            <div key={option.id} className={`p-4 rounded-lg border-2 ${option.enabled ? 'border-green-500' : 'border-gray-400'} ${isDarkMode ? 'bg-gray-600' : 'bg-gray-50'}`}>
              <div className="flex items-start gap-4">
                <div className="text-3xl">{option.icon}</div>
                <div className="flex-1 space-y-2">
                  <div className="grid grid-cols-2 gap-3">
                    <input
                      type="text"
                      value={option.title}
                      onChange={(e) => updateOption(option.id, 'title', e.target.value)}
                      className={`px-3 py-2 rounded border font-semibold ${isDarkMode ? 'bg-gray-700 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                    />
                    <input
                      type="text"
                      value={option.reward_range}
                      onChange={(e) => updateOption(option.id, 'reward_range', e.target.value)}
                      placeholder="Reward"
                      className={`px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  <input
                    type="text"
                    value={option.description}
                    onChange={(e) => updateOption(option.id, 'description', e.target.value)}
                    className={`w-full px-3 py-2 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                  />
                  <div className="flex gap-4 items-center">
                    <select
                      value={option.difficulty}
                      onChange={(e) => updateOption(option.id, 'difficulty', e.target.value)}
                      className={`px-3 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
                    >
                      <option value="easy">Easy</option>
                      <option value="medium">Medium</option>
                      <option value="hard">Hard</option>
                    </select>
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={option.enabled}
                        onChange={(e) => updateOption(option.id, 'enabled', e.target.checked)}
                        className="w-4 h-4"
                      />
                      <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Enabled</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Display Settings */}
      <div className={`p-4 mb-6 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}>
        <h5 className={`font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>🎨 Display Settings</h5>
        <div className="grid grid-cols-2 gap-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={settings.show_close_button !== false}
              onChange={(e) => onChange({...settings, show_close_button: e.target.checked})}
              className="w-4 h-4"
            />
            <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Show close button</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={settings.background_blur !== false}
              onChange={(e) => onChange({...settings, background_blur: e.target.checked})}
              className="w-4 h-4"
            />
            <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Background blur</span>
          </label>
          <div>
            <label className={`block text-sm font-semibold mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Animation Style
            </label>
            <select
              value={settings.animation_style}
              onChange={(e) => onChange({...settings, animation_style: e.target.value})}
              className={`w-full px-4 py-2 rounded border ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'}`}
            >
              <option value="bounce">Bounce</option>
              <option value="fade">Fade</option>
              <option value="slide">Slide</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex gap-4">
        <button
          onClick={() => {
            const previewWindow = window.open('', 'EarningPreview', 'width=600,height=800');
            previewWindow.document.write(`
              <!DOCTYPE html>
              <html>
              <head>
                <title>Earning Popup Preview</title>
                <style>
                  body {
                    margin: 0;
                    padding: 0;
                    font-family: system-ui, -apple-system, sans-serif;
                    background: rgba(0,0,0,0.7);
                    ${settings.background_blur ? 'backdrop-filter: blur(10px);' : ''}
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                  }
                  .modal {
                    background: white;
                    border-radius: 20px;
                    padding: 30px;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.5);
                    max-width: 500px;
                    width: 90%;
                    animation: ${settings.animation_style === 'bounce' ? 'bounce 0.5s' : settings.animation_style === 'fade' ? 'fadeIn 0.5s' : 'slideIn 0.5s'};
                  }
                  @keyframes bounce {
                    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
                    40% { transform: translateY(-30px); }
                    60% { transform: translateY(-15px); }
                  }
                  @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                  }
                  @keyframes slideIn {
                    from { transform: translateY(-100px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                  }
                  h2 {
                    color: #333;
                    margin: 0 0 10px 0;
                    font-size: 24px;
                  }
                  .subtitle {
                    color: #666;
                    margin-bottom: 20px;
                  }
                  .option {
                    border: 2px solid #e0e0e0;
                    border-radius: 12px;
                    padding: 15px;
                    margin-bottom: 12px;
                    cursor: pointer;
                    transition: all 0.3s;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                  }
                  .option:hover {
                    border-color: #667eea;
                    background: #f8f9ff;
                    transform: scale(1.02);
                  }
                  .option-icon {
                    font-size: 32px;
                  }
                  .option-content {
                    flex: 1;
                  }
                  .option-title {
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 4px;
                  }
                  .option-desc {
                    font-size: 13px;
                    color: #666;
                  }
                  .option-reward {
                    font-weight: bold;
                    color: #667eea;
                    font-size: 14px;
                  }
                  .close-btn {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: #f0f0f0;
                    border: none;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                    font-size: 18px;
                  }
                  .close-btn:hover {
                    background: #e0e0e0;
                  }
                </style>
              </head>
              <body>
                <div class="modal" style="position: relative;">
                  ${settings.show_close_button ? '<button class="close-btn" onclick="window.close()">×</button>' : ''}
                  <h2>${settings.title}</h2>
                  <p class="subtitle">${settings.subtitle}</p>
                  ${settings.options.filter(opt => opt.enabled).map((opt, idx) => 
                    '<div class="option" id="opt' + idx + '" onclick="selectOption(\'' + opt.id + '\', \'' + opt.title + '\', \'' + opt.reward_range + '\')">' +
                      '<div class="option-icon">' + opt.icon + '</div>' +
                      '<div class="option-content">' +
                        '<div class="option-title">' + opt.title + '</div>' +
                        '<div class="option-desc">' + opt.description + '</div>' +
                      '</div>' +
                      '<div class="option-reward">' + opt.reward_range + '</div>' +
                    '</div>'
                  ).join('')}
                  <div id="selection-result" style="margin-top: 20px; padding: 15px; border-radius: 10px; text-align: center; display: none;"></div>
                  <script>
                    let selectedOption = null;
                    
                    function selectOption(id, title, reward) {
                      // Remove previous selection
                      document.querySelectorAll('.option').forEach(opt => {
                        opt.style.borderColor = '#e0e0e0';
                        opt.style.background = '';
                        opt.style.transform = 'scale(1)';
                      });
                      
                      // Highlight selected
                      const selectedEl = event.currentTarget;
                      selectedEl.style.borderColor = '#667eea';
                      selectedEl.style.background = 'linear-gradient(135deg, #f8f9ff 0%, #e8f0fe 100%)';
                      selectedEl.style.transform = 'scale(1.02)';
                      
                      // Show result
                      const resultDiv = document.getElementById('selection-result');
                      resultDiv.style.display = 'block';
                      resultDiv.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
                      resultDiv.style.color = 'white';
                      var esc = function(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
                      resultDiv.innerHTML =
                        '<div style="font-size: 24px; margin-bottom: 10px;">✨ Great Choice!</div>' +
                        '<div style="font-size: 18px; font-weight: bold;">' + esc(title) + '</div>' +
                        '<div style="font-size: 14px; opacity: 0.9; margin-top: 5px;">Earn ' + esc(reward) + '</div>' +
                        '<div style="font-size: 12px; opacity: 0.8; margin-top: 10px;">In the real game, this would start the ' + esc(id) + ' activity</div>';
                      
                      selectedOption = id;
                      
                      // Animate
                      resultDiv.style.animation = 'fadeIn 0.5s';
                    }
                  </script>
                  <p style="text-align: center; color: #999; font-size: 12px; margin-top: 20px;">
                    Trigger: After ${settings.trigger_after_actions} actions (${Math.round(settings.trigger_probability * 100)}% chance)
                  </p>
                </div>
              </body>
              </html>
            `);
          }}
          className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold"
        >
          👁️ Preview Popup
        </button>
        <button
          onClick={onSave}
          className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-lg font-bold hover:shadow-lg transition-all"
        >
          💾 Save Settings
        </button>
      </div>
    </div>
  );
};

export const AnalyticsTab = ({ analytics, isDarkMode }) => {
  if (!analytics) return <div>Loading...</div>;
  
  const overview = analytics.overview || {};
  const engagement = analytics.engagement_30d || {};
  const popularItems = analytics.popular_items || [];
  const bestSelling = analytics.best_selling_items || [];
  const topMerchants = analytics.top_merchants || [];
  
  return (
    <div>
      <h4 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        📊 Game Analytics (Last 30 Days)
      </h4>

      {/* Overview Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 text-white p-6 rounded-xl shadow-lg">
          <div className="text-4xl mb-2">👥</div>
          <div className="text-3xl font-bold">{overview.total_users || 0}</div>
          <div className="text-sm opacity-90">Total Users</div>
        </div>
        <div className="bg-gradient-to-br from-green-500 to-green-600 text-white p-6 rounded-xl shadow-lg">
          <div className="text-4xl mb-2">🔥</div>
          <div className="text-3xl font-bold">{overview.active_users_7d || 0}</div>
          <div className="text-sm opacity-90">Active (7 days)</div>
        </div>
        <div className="bg-gradient-to-br from-purple-500 to-purple-600 text-white p-6 rounded-xl shadow-lg">
          <div className="text-4xl mb-2">🏪</div>
          <div className="text-3xl font-bold">{overview.total_merchants || 0}</div>
          <div className="text-sm opacity-90">Total Merchants</div>
        </div>
        <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white p-6 rounded-xl shadow-lg">
          <div className="text-4xl mb-2">👕</div>
          <div className="text-3xl font-bold">{overview.total_items || 0}</div>
          <div className="text-sm opacity-90">Total Items</div>
        </div>
      </div>

      {/* Engagement Stats */}
      <div className={`p-6 rounded-xl mb-6 ${isDarkMode ? 'bg-gray-700' : 'bg-blue-50'}`}>
        <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          📈 User Engagement (30 Days)
        </h5>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-600">{engagement.quizzes_taken || 0}</div>
            <div className="text-sm text-gray-600">🧠 Quizzes Taken</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-green-600">{engagement.phrases_learned || 0}</div>
            <div className="text-sm text-gray-600">💬 Phrases Learned</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-orange-600">{engagement.wheel_spins || 0}</div>
            <div className="text-sm text-gray-600">🎡 Wheel Spins</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-600">{engagement.missions_completed || 0}</div>
            <div className="text-sm text-gray-600">🎯 Missions Done</div>
          </div>
        </div>
      </div>

      {/* Popular Items & Top Merchants */}
      <div className="grid grid-cols-2 gap-6">
        <div className={`p-6 rounded-xl ${isDarkMode ? 'bg-gray-700' : 'bg-white border-2 border-gray-200'}`}>
          <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            🔥 Popular Items (Most Viewed)
          </h5>
          {popularItems.length > 0 ? (
            <div className="space-y-2">
              {popularItems.slice(0, 5).map((item, idx) => (
                <div key={idx} className="flex justify-between items-center py-2 border-b border-gray-200">
                  <div className="flex-1">
                    <div className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                      {item.item_name || item._id.substring(0, 12) + '...'}
                    </div>
                    {item.item_name && (
                      <div className="text-xs text-gray-400">ID: {item._id.substring(0, 8)}...</div>
                    )}
                  </div>
                  <span className="font-bold text-blue-600">{item.count} views</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-sm">No data yet</p>
          )}
        </div>

        <div className={`p-6 rounded-xl ${isDarkMode ? 'bg-gray-700' : 'bg-white border-2 border-gray-200'}`}>
          <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            🏆 Top Merchants (Most Visited)
          </h5>
          {topMerchants.length > 0 ? (
            <div className="space-y-2">
              {topMerchants.slice(0, 5).map((merchant, idx) => (
                <div key={idx} className="flex justify-between items-center py-2 border-b border-gray-200">
                  <div className="flex-1">
                    <div className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                      {merchant.merchant_name || merchant._id.substring(0, 12) + '...'}
                    </div>
                    {merchant.merchant_name && (
                      <div className="text-xs text-gray-400">ID: {merchant._id.substring(0, 8)}...</div>
                    )}
                  </div>
                  <span className="font-bold text-green-600">{merchant.count} visits</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-sm">No data yet</p>
          )}
        </div>
      </div>

      {/* Mission Stats */}
      {engagement.missions_started > 0 && (
        <div className={`p-6 rounded-xl mt-6 ${isDarkMode ? 'bg-gray-700' : 'bg-purple-50'}`}>
          <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            🎯 Mission Performance
          </h5>
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">{engagement.missions_started || 0}</div>
              <div className="text-sm text-gray-600">Started</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">{engagement.missions_completed || 0}</div>
              <div className="text-sm text-gray-600">Completed</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600">{engagement.completion_rate || 0}%</div>
              <div className="text-sm text-gray-600">Success Rate</div>
            </div>
          </div>
        </div>
      )}

      {/* Best Selling Items */}
      {bestSelling.length > 0 && (
        <div className={`p-6 rounded-xl mt-6 ${isDarkMode ? 'bg-gray-700' : 'bg-white border-2 border-gray-200'}`}>
          <h5 className={`font-bold text-lg mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            💰 Best Selling Items
          </h5>
          <div className="space-y-3">
            {bestSelling.slice(0, 5).map((item, idx) => (
              <div key={idx} className="flex justify-between items-center py-2 border-b border-gray-200">
                <div className="flex-1">
                  <div className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                    {item.item_name || item._id.substring(0, 12) + '...'}
                  </div>
                  <div className="text-xs text-gray-500">{item.count} purchases</div>
                  {item.item_name && (
                    <div className="text-xs text-gray-400">ID: {item._id.substring(0, 8)}...</div>
                  )}
                </div>
                <span className="font-bold text-green-600">{Math.round(item.revenue || 0)} DH</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Edit Modals
export const QuizEditModal = ({ quiz, onSave, onClose, isDarkMode }) => {
  const [formData, setFormData] = useState(quiz || {
    question: '',
    options: ['', '', '', ''],
    correct_index: 0,
    difficulty: 'easy',
    category: 'darija',
    reward: 30,
    penalty: 10,
    is_active: true
  });

  const handleOptionChange = (idx, value) => {
    const newOptions = [...formData.options];
    newOptions[idx] = value;
    setFormData({...formData, options: newOptions});
  };

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className={`rounded-xl shadow-2xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`} onClick={(e) => e.stopPropagation()}>
        <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          {quiz?.id ? 'Edit Quiz' : 'Add Quiz'}
        </h3>

        <div className="space-y-4">
          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Question *
            </label>
            <input
              type="text"
              value={formData.question}
              onChange={(e) => setFormData({...formData, question: e.target.value})}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="Enter quiz question"
            />
          </div>

          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Options (4 required) *
            </label>
            {formData.options.map((opt, idx) => (
              <div key={idx} className="flex gap-2 mb-2">
                <input
                  type="radio"
                  checked={formData.correct_index === idx}
                  onChange={() => setFormData({...formData, correct_index: idx})}
                  className="mt-2"
                />
                <input
                  type="text"
                  value={opt}
                  onChange={(e) => handleOptionChange(idx, e.target.value)}
                  className={`flex-1 px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  placeholder={`Option ${idx + 1}`}
                />
              </div>
            ))}
            <p className="text-xs text-gray-500 mt-1">Select the correct answer with the radio button</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Difficulty
              </label>
              <select
                value={formData.difficulty}
                onChange={(e) => setFormData({...formData, difficulty: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Category
              </label>
              <select
                value={formData.category}
                onChange={(e) => setFormData({...formData, category: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="darija">Darija</option>
                <option value="math">Math</option>
                <option value="culture">Culture</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Reward (DH)
              </label>
              <input
                type="number"
                value={formData.reward}
                onChange={(e) => setFormData({...formData, reward: parseInt(e.target.value)})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Penalty (DH)
              </label>
              <input
                type="number"
                value={formData.penalty}
                onChange={(e) => setFormData({...formData, penalty: parseInt(e.target.value)})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
              className="w-4 h-4"
            />
            <label className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Active
            </label>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={handleSubmit}
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="px-6 py-3 rounded-lg font-semibold bg-gray-200 hover:bg-gray-300 text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export const TipEditModal = ({ tip, onSave, onClose, isDarkMode }) => {
  const [formData, setFormData] = useState(tip || {
    title: '',
    tip: '',
    emoji: '💡',
    category: 'general',
    is_active: true
  });

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className={`rounded-xl shadow-2xl max-w-2xl w-full p-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`} onClick={(e) => e.stopPropagation()}>
        <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          {tip?.id ? 'Edit Cultural Tip' : 'Add Cultural Tip'}
        </h3>

        <div className="space-y-4">
          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Title *
            </label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g., Bargaining Tips"
            />
          </div>

          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Tip Content *
            </label>
            <textarea
              value={formData.tip}
              onChange={(e) => setFormData({...formData, tip: e.target.value})}
              rows={4}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="Enter the cultural tip..."
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Emoji
              </label>
              <input
                type="text"
                value={formData.emoji}
                onChange={(e) => setFormData({...formData, emoji: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="💡"
              />
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Category
              </label>
              <select
                value={formData.category}
                onChange={(e) => setFormData({...formData, category: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="general">General</option>
                <option value="bargaining">Bargaining</option>
                <option value="etiquette">Etiquette</option>
                <option value="shopping">Shopping</option>
                <option value="culture">Culture</option>
              </select>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
              className="w-4 h-4"
            />
            <label className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Active
            </label>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={() => onSave(formData)}
            className="flex-1 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="px-6 py-3 rounded-lg font-semibold bg-gray-200 hover:bg-gray-300 text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export const PhraseEditModal = ({ phrase, onSave, onClose, isDarkMode }) => {
  const [formData, setFormData] = useState(phrase || {
    darija: '',
    english: '',
    pronunciation: '',
    emoji: '💬',
    category: 'general',
    is_active: true
  });

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className={`rounded-xl shadow-2xl max-w-2xl w-full p-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`} onClick={(e) => e.stopPropagation()}>
        <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          {phrase?.id ? 'Edit Darija Phrase' : 'Add Darija Phrase'}
        </h3>

        <div className="space-y-4">
          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Darija Phrase *
            </label>
            <input
              type="text"
              value={formData.darija}
              onChange={(e) => setFormData({...formData, darija: e.target.value})}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g., Bsh7al hadi?"
            />
          </div>

          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              English Translation *
            </label>
            <input
              type="text"
              value={formData.english}
              onChange={(e) => setFormData({...formData, english: e.target.value})}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g., How much is this?"
            />
          </div>

          <div>
            <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Pronunciation Guide *
            </label>
            <input
              type="text"
              value={formData.pronunciation}
              onChange={(e) => setFormData({...formData, pronunciation: e.target.value})}
              className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g., besh-hal ha-dee"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Emoji
              </label>
              <input
                type="text"
                value={formData.emoji}
                onChange={(e) => setFormData({...formData, emoji: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="💬"
              />
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Category
              </label>
              <select
                value={formData.category}
                onChange={(e) => setFormData({...formData, category: e.target.value})}
                className={`w-full px-3 py-2 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="general">General</option>
                <option value="shopping">Shopping</option>
                <option value="bargaining">Bargaining</option>
                <option value="greeting">Greeting</option>
              </select>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
              className="w-4 h-4"
            />
            <label className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Active
            </label>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={() => onSave(formData)}
            className="flex-1 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="px-6 py-3 rounded-lg font-semibold bg-gray-200 hover:bg-gray-300 text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
